(function () {
  "use strict";

  RemindTraineesCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('RemindTraineesCtrl', RemindTraineesCtrl);

  function RemindTraineesCtrl($scope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: '',
      showSecondLine: false,
      alreadyReminded: 0
    };

    $scope.remindTrainees = function () {
      $scope.modal.status = 'saving';
      $scope.$emit('remindTraineesConfirmEvent', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('traineesToRemindEvent', function (event, numberOfTrainees, data) {
      $scope.modal.status = '';
      $scope.modal.data = data || {};
      $scope.modal.content = numberOfTrainees;
      $scope.modal.showSecondLine = false;
      if ($scope.modal.data.totalCount && $scope.modal.data.totalCount > numberOfTrainees) {
        $scope.modal.alreadyReminded = $scope.modal.data.totalCount - numberOfTrainees;
        $scope.modal.showSecondLine = true;
      }
    });

    $scope.$on('remindTraineeEvent', function (event, trainee) {
      if (!trainee) return;
      $scope.modal.content = 1;
      $scope.modal.data = trainee;
      $scope.show();
    });
  }

})();
